import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import * as model from '../../models';
import { Observable } from 'rxjs/Observable';
import { OauthHelper } from '../../services/webservice/oauth-helper.service';

@Injectable()
export class PrinterApi {
	private printcloudAdminApi = '/api/printcloud/v1/admin';

	private orderURL = "";
	private deliveryURL = "";
	constructor(private httpClient: HttpClient,
		private oauthHelper: OauthHelper,
	) { }

	public getPrinters() {
		return this.httpClient.get(this.printcloudAdminApi)
			.map(response => response.json())
	}
	public getPrinter(printerId: string) {
		return this.httpClient.get(`${this.printcloudAdminApi}/${printerId}`)
			.map(response => response.json())
	}
	public updatePrinter(printerId: string,
		data: { name: string, paperName: string, printerName: string, scaleToPaperSize: boolean, landscape: boolean }) {
		let body = JSON.stringify(data)
		return this.httpClient.post(`${this.printcloudAdminApi}/${printerId}`, body)
			.map(response => response.json())
	}

	public getPrinterInfo(printerId: string) {
		return this.httpClient.get(`${this.printcloudAdminApi}/${printerId}/GET_INFO`)
			.map(response => response.json())
	}

	public printTicket(imgUrl: string, printerId: string) {
		const ourToken = this.oauthHelper.getAccessToken();
		const data = {
			token: ourToken,
			imgUrl: imgUrl
		}
		let body = JSON.stringify(data)
		return this.httpClient.put(`${this.printcloudAdminApi}/${printerId}/PRINT`, body)
			.map(response => response.json());
	}

	public printTickets(imgUrls: string[], printerId: string) {
		const ourToken = this.oauthHelper.getAccessToken();
		const dataArray = imgUrls.map(href => ({token: ourToken, imgUrl: href}));
		let body = JSON.stringify(dataArray)
		return this.httpClient.put(`${this.printcloudAdminApi}/${printerId}/PRINT/BATCH`, body)
			.map(response => response.json());
	}

	public createPrinter(dto: {name: string, id: string, secret: string}): Observable<model.Printer> {
		let body = JSON.stringify(dto)
		return this.httpClient.post(this.printcloudAdminApi, body)
			.map(response => <model.Printer>response.json())
	}

	public deletePrinter(printerId: String) {
		return this.httpClient.delete(`${this.printcloudAdminApi}/${printerId}`)
			.map(response => response.json())
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/printer-api.service.ts